import SubLanding from "@/components/SubLanding";
export default function EpictetusAI() { return <SubLanding slug="epictetus-ai" />; }
